import { paths } from '@app/routes/paths';
import type { Role } from '@features/auth';
import { useAuth } from '@features/auth';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import type { RoleMode } from '../utils/roles';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: readonly Role[] | undefined;
  mode?: RoleMode | undefined;
}

export function ProtectedRoute({ children, requiredRoles, mode = 'any' }: ProtectedRouteProps) {
  const { isAuthenticated, hasRole, status } = useAuth();
  const location = useLocation();

  if (status === 'idle' || status === 'booting') {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={paths.login} state={{ from: location }} replace />;
  }

  if (!hasRole(requiredRoles, mode)) {
    return <Navigate to={paths.forbidden} replace />;
  }

  return <>{children}</>;
}
